export default {
    // 中
    zhCN: {
        model: '车型',
        mileage: '里程数',
        functiontype: '功能类型',
        functiontypedesp_zh: '功能类型描述(中文)',
        functiontypedesp_en: '功能类型描述(英文)',
        channel: '通道',
        channeldesp_zh: '通道描述(中文)',
        channeldesp_en: '通道描述(英文)',
        functionstarttime: '功能开始时间',
        OS_version_beforere_freshing: '刷新前整车软件OS版本',
        part_number_before_refreshing: '刷新前整车软件零件号',
        vehicle_software_OS_version: '车软件OS版本',
        controller_name: '控制器名称',
        hardware_number: '硬件号',
        software_information_before_Refresh: '刷新前的软件信息',
        software_information_after_Refresh: '刷新后的软件信息',
        write_software_information: '写入软件信息',
        function_name: '功能名',
        minor_process_execution_time: '小流程执行时长',
        small_process_execution_result: '小流程执行结果',
        function_execution_time: '功能执行时长',
        function_execution_result: '功能执行结果',
        function_execution_result_desp_zh: '功能执行结果描述(中文)',
        function_execution_result_desp_en: '功能执行结果描述(英文)',
        log_start_time: 'Log开始时间',
        log_end_time: 'Log结束时间',
        vehicle_recognition_method: '车辆识别方式',
        vehicle_recognition_method_desp_zh: '车辆识别方式描述(中文)',
        vehicle_recognition_method_desp_en: '车辆识别方式描述(英文)',
        model_year: '年款',
        vehicle_configuration_information: '车辆配置信息',
        platform: '平台',
        login_account: '登录账号',
        user_name: '用户名称',
        service_center: '服务中心',
        SIPS_version: 'SIPS版本',
        VDI_version: 'VDI版本',
        VDI_connection_method: 'VDI连接方式',
        VDI_connection_method_desp_zh: 'VDI连接方式描述(中文)',
        VDI_connection_method_desp_en: 'VDI连接方式描述(英文)',
        operating_system: '操作系统',
        operating_system_zh: '操作系统(中文)',
        operating_system_en: '操作系统(英文)',
        brand: '品牌',
        country_region: '国家/地区',
    },
    // 英
    enUS: {
        model: 'Model',
        mileage: 'Mileage',
        functiontype: 'Function Type',
        functiontypedesp_zh: 'Function Type Description (Chinese)',
        functiontypedesp_en: 'Function Type Description (English)',
        channel: 'Channel',
        channeldesp_zh: 'Channel Description (Chinese)',
        channeldesp_en: 'Channel Description (English)',
        functionstarttime: 'Function Start Time',
        OS_version_beforere_freshing: 'Vehicle software OS version before refreshing',
        part_number_before_refreshing: 'Vehicle software part number before refreshing',
        vehicle_software_OS_version: 'Vehicle software OS version',
        controller_name: 'Controller Name',
        hardware_number: 'Hardware number',
        software_information_before_Refresh: 'Software Information Before Refresh',
        software_information_after_Refresh: 'Software information after refreshing',
        write_software_information: 'Write Software Information',
        function_name: 'Function name',
        minor_process_execution_time: 'Minor process execution time',
        small_process_execution_result: 'Small process execution result',
        function_execution_time: 'Function execution time',
        function_execution_result: 'Function Execution Result',
        function_execution_result_desp_zh: 'Function Execution Result Description (Chinese)',
        function_execution_result_desp_en: 'Function Execution Result Description (English)',
        log_start_time: 'Log start time',
        log_end_time: 'Log end time',
        vehicle_recognition_method: 'Vehicle Recognition Method',
        vehicle_recognition_method_desp_zh: 'Vehicle Recognition Method Description (Chinese)',
        vehicle_recognition_method_desp_en: 'Vehicle Recognition Method Description (English)',
        model_year: 'Model Year',
        vehicle_configuration_information: 'Vehicle Configuration Information',
        platform: 'Platform',
        login_account: 'Login Account',
        user_name: 'User Name',
        service_center: 'Service Center',
        SIPS_version: 'SIPS Version',
        VDI_version: 'VDI Version',
        VDI_connection_method: 'VDI Connection Method',
        VDI_connection_method_desp_zh: 'Description of VDI connection method (Chinese)',
        VDI_connection_method_desp_en: 'Description of VDI connection method (English)',
        operating_system: 'Operating System',
        operating_system_zh: 'Operating System(Chinese)',
        operating_system_en: 'Operating System(English)',
        brand: 'Brand',
        country_region: 'Country/Region',
    },
    // 德
    deDE: {
        model: 'Modell',
        mileage: 'Kilometerstand',
        functiontype: 'Funktion Typ',
        functiontypedesp_zh: 'Beschreibung des Funktionstyps (Chinesisch)',
        functiontypedesp_en: 'Funktionstyp Beschreibung (Englisch)',
        channel: 'Kanal',
        channeldesp_zh: 'Kanalbeschreibung (Chinesisch)',
        channeldesp_en: 'Kanalbeschreibung (Englisch)',
        functionstarttime: 'Funktion Startzeit',
        OS_version_beforere_freshing:
            'Version des Betriebssystems der Fahrzeugsoftware vor der Auffrischung',
        part_number_before_refreshing: 'Teilnummer der Fahrzeugsoftware vor der Aktualisierung',
        vehicle_software_OS_version: 'Version des Betriebssystems der Fahrzeugsoftware',
        controller_name: 'Name des Steuergeräts',
        hardware_number: 'Hardware-Nummer',
        software_information_before_Refresh: 'Software-Informationen vor der Auffrischung',
        software_information_after_Refresh: 'Software-Informationen nach der Auffrischung',
        write_software_information: 'Schreiben von Software-Informationen',
        function_name: 'Name der Funktion',
        minor_process_execution_time: 'Kleine Prozessausführungszeit',
        small_process_execution_result: 'Ergebnis der Ausführung eines kleinen Prozesses',
        function_execution_time: 'Ausführungszeit der Funktion',
        function_execution_result: 'Funktion Ausführungsergebnis',
        function_execution_result_desp_zh:
            'Beschreibung des Funktionsausführungsergebnisses (Chinesisch)',
        function_execution_result_desp_en: 'Funktion Ausführungsergebnis Beschreibung (Englisch)',
        log_start_time: 'Startzeit des Protokolls',
        log_end_time: 'Endzeit des Protokolls',
        vehicle_recognition_method: 'Fahrzeugerkennungsmethode',
        vehicle_recognition_method_desp_zh:
            'Beschreibung der Fahrzeugerkennungsmethode (Chinesisch)',
        vehicle_recognition_method_desp_en: 'Beschreibung der Fahrzeugerkennungsmethode (Englisch)',
        model_year: 'Modelljahr',
        vehicle_configuration_information: 'Informationen zur Fahrzeugkonfiguration',
        platform: 'Plattform',
        login_account: 'Login-Konto',
        user_name: 'Benutzer Name',
        service_center: 'Service-Zentrum',
        SIPS_version: 'SIPS-Version',
        VDI_version: 'VDI-Version',
        VDI_connection_method: 'VDI-Verbindung',
        VDI_connection_method_desp_zh: 'Beschreibung der VDI-Verbindungsmethode (Chinesisch)',
        VDI_connection_method_desp_en: 'Beschreibung der VDI-Verbindung (Englisch)',
        operating_system: 'Betriebssystem',
        operating_system_zh: 'Betriebssystem (Chinesisch)',
        operating_system_en: 'Betriebssystem (Englisch)',
        brand: 'Marke',
        country_region: 'Land/Region',
    },
    // 法
    frFR: {
        model: 'modèle',
        mileage: 'kilométrage',
        functiontype: 'Type de fonction',
        functiontypedesp_zh: 'Type de fonction Description (chinois)',
        functiontypedesp_en: 'Description du type de fonction (anglais)',
        channel: 'Canal',
        channeldesp_zh: 'Description du canal (chinois)',
        channeldesp_en: 'Description du canal (anglais)',
        functionstarttime: 'Heure de démarrage de la fonction',
        OS_version_beforere_freshing: 'Version du logiciel du véhicule avant actualisation',
        part_number_before_refreshing:
            'Numéro de pièce du logiciel du véhicule avant rafraîchissemen',
        vehicle_software_OS_version: 'Version du système d\'exploitation du logiciel du véhicule',
        controller_name: 'Nom du contrôleur',
        hardware_number: 'Numéro du matériel',
        software_information_before_Refresh: 'Informations sur le logiciel avant rafraîchissement',
        software_information_after_Refresh: 'Informations sur le logiciel après rafraîchissement',
        write_software_information: 'Écriture des informations sur le logiciel',
        function_name: 'Nom de la fonction',
        minor_process_execution_time: 'Temps d\'exécution du processus mineur',
        small_process_execution_result: 'Résultat de l\'exécution du processus mineur',
        function_execution_time: 'Temps d\'exécution de la fonction',
        function_execution_result: 'Résultat de l\'exécution de la fonction',
        function_execution_result_desp_zh:
            'Description du résultat de l\'exécution de la fonction (chinois)',
        function_execution_result_desp_en:
            'Description du résultat de l\'exécution de la fonction (anglais)',
        log_start_time: 'Heure de début du journal',
        log_end_time: 'Heure de fin du journal',
        vehicle_recognition_method: 'Méthode de reconnaissance des véhicules',
        vehicle_recognition_method_desp_zh:
            'Description de la méthode de reconnaissance des véhicules (chinois)',
        vehicle_recognition_method_desp_en:
            'Description de la méthode de reconnaissance des véhicules (anglais)',
        model_year: 'Année du modèle',
        vehicle_configuration_information: 'Informations sur la configuration du véhicule',
        platform: 'Plateforme',
        login_account: 'Compte de connexion',
        user_name: 'Nom d\'utilisateur',
        service_center: 'Centre de service',
        SIPS_version: 'Version SIPS',
        VDI_version: 'Version VDI',
        VDI_connection_method: 'Méthode de connexion VDI',
        VDI_connection_method_desp_zh: 'Description de la méthode de connexion VDI (chinois)',
        VDI_connection_method_desp_en: 'Description de la connexion VDI (anglais)',
        operating_system: 'Système d\'exploitation',
        operating_system_zh: 'Système d\'exploitation (chinois)',
        operating_system_en: 'Système d\'exploitation (anglais)',
        brand: 'Marque',
        country_region: 'Pays/Région',
    },
    // 意大利
    itIT: {
        model: 'modello',
        mileage: 'chilometraggio',
        functiontype: 'Tipo di funzione',
        functiontypedesp_zh: 'Descrizione del tipo di funzione (cinese)',
        functiontypedesp_en: 'Descrizione del tipo di funzione (inglese)',
        channel: 'Canale',
        channeldesp_zh: 'Descrizione del canale (cinese)',
        channeldesp_en: 'Descrizione del canale (inglese)',
        functionstarttime: 'Funzione Tempo di avvio',
        OS_version_beforere_freshing: 'Versione software OS del veicolo prima dell\'aggiornamento',
        part_number_before_refreshing:
            'Numero di parte del software del veicolo prima dell\'aggiornamento',
        vehicle_software_OS_version: 'Versione OS del software del veicolo',
        controller_name: 'Nome del controllore',
        hardware_number: 'Numero di hardware',
        software_information_before_Refresh: 'Informazioni sul software prima del refresh',
        software_information_after_Refresh: 'Informazioni sul software dopo l\'aggiornamento',
        write_software_information: 'Scrivi informazioni sul software',
        function_name: 'Nome della funzione',
        minor_process_execution_time: 'Tempo di esecuzione del processo minore',
        small_process_execution_result: 'Risultato dell\'esecuzione del processo minore',
        function_execution_time: 'Tempo di esecuzione della funzione',
        function_execution_result: 'Risultato dell\'esecuzione della funzione',
        function_execution_result_desp_zh:
            'Descrizione del risultato dell\'esecuzione della funzione (cinese)',
        function_execution_result_desp_en:
            'Descrizione del risultato dell\'esecuzione della funzione (inglese)',
        log_start_time: 'Ora di inizio del registro',
        log_end_time: 'Ora di fine registro',
        vehicle_recognition_method: 'Metodo di riconoscimento del veicolo',
        vehicle_recognition_method_desp_zh:
            'Descrizione del metodo di riconoscimento del veicolo (cinese)',
        vehicle_recognition_method_desp_en:
            'Descrizione del metodo di riconoscimento del veicolo (inglese)',
        model_year: 'Anno modello',
        vehicle_configuration_information: 'Informazioni sulla configurazione del veicolo',
        platform: 'Piattaforma',
        login_account: 'Account di accesso',
        user_name: 'Nome utente',
        service_center: 'Centro servizi',
        SIPS_version: 'Versione SIPS',
        VDI_version: 'Versione VDI',
        VDI_connection_method: 'Metodo di connessione VDI',
        VDI_connection_method_desp_zh: 'Descrizione del metodo di connessione VDI (cinese)',
        VDI_connection_method_desp_en: 'Descrizione della connessione VDI (inglese)',
        operating_system: 'Sistema operativo',
        operating_system_zh: 'Sistema operativo (cinese)',
        operating_system_en: 'Sistema operativo (inglese)',
        brand: 'Marchio',
        country_region: 'Paese/Regione',
    },
    // 荷兰
    nlNL: {
        model: 'Model',
        mileage: 'Kilometerstand',
        functiontype: 'Functietype',
        functiontypedesp_zh: 'Functietype Beschrijving (Chinees)',
        functiontypedesp_en: 'Functietype Beschrijving (Engels)',
        channel: 'Kanaal',
        channeldesp_zh: 'Beschrijving kanaal (Chinees)',
        channeldesp_en: 'Beschrijving kanaal (Engels)',
        functionstarttime: 'Functie starttijd',
        OS_version_beforere_freshing: 'OS-versie voertuigsoftware vóór vernieuwing',
        part_number_before_refreshing: 'Onderdeelnummer voertuigsoftware vóór vernieuwen',
        vehicle_software_OS_version: 'OS-versie voertuigsoftware',
        controller_name: 'Naam controller',
        hardware_number: 'Hardware nummer',
        software_information_before_Refresh: 'Software-informatie vóór verversen',
        software_information_after_Refresh: 'Software-informatie na verversen',
        write_software_information: 'Software-informatie schrijven',
        function_name: 'Naam functie',
        minor_process_execution_time: 'Kleine procesuitvoeringstijd',
        small_process_execution_result: 'Resultaat uitvoering klein proces',
        function_execution_time: 'Tijd uitvoering functie',
        function_execution_result: 'Resultaat van functie-uitvoering',
        function_execution_result_desp_zh:
            'Beschrijving van het resultaat van de functie-uitvoering (Chinees)',
        function_execution_result_desp_en:
            'Beschrijving van het functie-uitvoeringresultaat (Engels)',
        log_start_time: 'Begintijd log',
        log_end_time: 'Eindtijd log',
        vehicle_recognition_method: 'Methode voertuigherkenning',
        vehicle_recognition_method_desp_zh: 'Beschrijving voertuigherkenningsmethode (Chinees)',
        vehicle_recognition_method_desp_en: 'Beschrijving voertuigherkenningsmethode (Engels)',
        model_year: 'Modeljaar',
        vehicle_configuration_information: 'Informatie over voertuigconfiguratie',
        platform: 'Platform',
        login_account: 'Inlogaccount',
        user_name: 'Gebruikersnaam',
        service_center: 'Servicecentrum',
        SIPS_version: 'SIPS-versie',
        VDI_version: 'VDI-versie',
        VDI_connection_method: 'VDI-verbindingsmethode',
        VDI_connection_method_desp_zh: 'Beschrijving van VDI-verbindingsmethode (Chinees)',
        VDI_connection_method_desp_en: 'Beschrijving VDI-verbinding (Engels)',
        operating_system: 'Besturingssysteem',
        operating_system_zh: 'Besturingssysteem (Chinees)',
        operating_system_en: 'Besturingssysteem (Engels)',
        brand: 'Merk',
        country_region: 'Land/regio',
    },
    // 越南
    viVN: {
        model: 'Mô hình',
        mileage: 'Số dặm',
        functiontype: 'Loại chức năng',
        functiontypedesp_zh: 'Mô tả loại chức năng (Tiếng Trung)',
        functiontypedesp_en: 'Mô tả loại chức năng (Tiếng Anh)',
        channel: 'Kênh',
        channeldesp_zh: 'Mô tả kênh (Tiếng Trung)',
        channeldesp_en: 'Mô tả kênh (Tiếng Anh)',
        functionstarttime: 'Thời gian bắt đầu chức năng',
        OS_version_beforere_freshing: 'Phiên bản hệ điều hành phương tiện trước khi làm mới',
        part_number_before_refreshing: 'Số phần mềm phương tiện trước khi làm mới',
        vehicle_software_OS_version: 'Phiên bản hệ điều hành phần mềm phương tiện',
        controller_name: 'Tên bộ điều khiển',
        hardware_number: 'Số phần cứng',
        software_information_before_Refresh: 'Thông tin phần mềm trước khi làm mới',
        software_information_after_Refresh: 'Thông tin phần mềm sau khi làm mới',
        write_software_information: 'Viết thông tin phần mềm',
        function_name: 'Tên chức năng',
        minor_process_execution_time: 'Thời gian thực hiện quá trình nhỏ',
        small_process_execution_result: 'Kết quả thực hiện quá trình nhỏ',
        function_execution_time: 'Thời gian thực hiện chức năng',
        function_execution_result: 'Kết quả thực hiện chức năng',
        function_execution_result_desp_zh: 'Mô tả kết quả thực hiện chức năng (Tiếng Trung)',
        function_execution_result_desp_en: 'Mô tả kết quả thực hiện chức năng (Tiếng Anh)',
        log_start_time: 'Thời gian bắt đầu ghi nhật ký',
        log_end_time: 'Thời gian kết thúc ghi nhật ký',
        vehicle_recognition_method: 'Phương pháp nhận dạng phương tiện',
        vehicle_recognition_method_desp_zh: 'Mô tả phương pháp nhận dạng phương tiện (Tiếng Trung)',
        vehicle_recognition_method_desp_en: 'Mô tả phương pháp nhận dạng phương tiện (Tiếng Anh)',
        model_year: 'Năm sản xuất',
        vehicle_configuration_information: 'Thông tin cấu hình phương tiện',
        platform: 'Nền tảng',
        login_account: 'Tài khoản đăng nhập',
        user_name: 'Tên người dùng',
        service_center: 'Trung tâm dịch vụ',
        SIPS_version: 'Phiên bản SIPS',
        VDI_version: 'Phiên bản VDI',
        VDI_connection_method: 'Phương pháp kết nối VDI',
        VDI_connection_method_desp_zh: 'Mô tả phương pháp kết nối VDI (Tiếng Trung)',
        VDI_connection_method_desp_en: 'Mô tả phương pháp kết nối VDI (Tiếng Anh)',
        operating_system: 'Hệ điều hành',
        operating_system_zh: 'Hệ điều hành (Tiếng Trung)',
        operating_system_en: 'Hệ điều hành (Tiếng Anh)',
        brand: 'Thương hiệu',
        country_region: 'Quốc gia/Khu vực',
    },
    // 西班牙
    esES: {
        model: 'Modelo',
        mileage: 'Kilometraje',
        functiontype: 'Tipo de función',
        functiontypedesp_zh: 'Descripción del tipo de función (chino)',
        functiontypedesp_en: 'Descripción del tipo de función (inglés)',
        channel: 'Canal',
        channeldesp_zh: 'Descripción del canal (chino)',
        channeldesp_en: 'Descripción del canal (inglés)',
        functionstarttime: 'Hora de inicio de la función',
        OS_version_beforere_freshing:
            'Versión del SO del software del vehículo antes de la actualización',
        part_number_before_refreshing:
            'Número de pieza del software del vehículo antes de actualizar',
        vehicle_software_OS_version: 'Versión del SO del software del vehículo',
        controller_name: 'Nombre del controlador',
        hardware_number: 'Número de hardware',
        software_information_before_Refresh: 'Información del software antes de actualizar',
        software_information_after_Refresh: 'Información del software después de la actualización',
        write_software_information: 'Escribir información de software',
        function_name: 'Nombre de la función',
        minor_process_execution_time: 'Tiempo de ejecución de proceso menor',
        small_process_execution_result: 'Resultado de ejecución de proceso menor',
        function_execution_time: 'Tiempo de ejecución de la función',
        function_execution_result: 'Resultado de la ejecución de la función',
        function_execution_result_desp_zh:
            'Descripción del resultado de la ejecución de la función (chino)',
        function_execution_result_desp_en:
            'Descripción del resultado de la ejecución de la función (inglés)',
        log_start_time: 'Hora de inicio del registro',
        log_end_time: 'Hora de finalización del registro',
        vehicle_recognition_method: 'Método de reconocimiento de vehículos',
        vehicle_recognition_method_desp_zh:
            'Descripción del método de reconocimiento de vehículos (chino)',
        vehicle_recognition_method_desp_en:
            'Descripción del método de reconocimiento de vehículos (inglés)',
        model_year: 'Año del modelo',
        vehicle_configuration_information: 'Información sobre la configuración del vehículo',
        platform: 'Plataforma',
        login_account: 'Cuenta de inicio de sesión',
        user_name: 'Nombre de usuario',
        service_center: 'Centro de servicio',
        SIPS_version: 'Versión SIPS',
        VDI_version: 'Versión VDI',
        VDI_connection_method: 'Método de conexión VDI',
        VDI_connection_method_desp_zh: 'Descripción del método de conexión VDI (chino)',
        VDI_connection_method_desp_en: 'Descripción de la conexión VDI (inglés)',
        operating_system: 'Sistema operativo',
        operating_system_zh: 'Sistema operativo (chino)',
        operating_system_en: 'Sistema operativo (inglés)',
        brand: 'Marca',
        country_region: 'País/Región',
    },
    // 葡萄牙
    ptBR: {
        model: 'Modelo',
        mileage: 'Quilometragem',
        functiontype: 'Tipo de função',
        functiontypedesp_zh: 'Descrição do tipo de função (chinês)',
        functiontypedesp_en: 'Descrição do tipo de função (inglês)',
        channel: 'Canal',
        channeldesp_zh: 'Descrição do canal (chinês)',
        channeldesp_en: 'Descrição do canal (inglês)',
        functionstarttime: 'Função Hora de início',
        OS_version_beforere_freshing: 'Versão do SO do software do veículo antes da atualização',
        part_number_before_refreshing: 'Número de peça do software do veículo antes da atualização',
        vehicle_software_OS_version: 'Versão do SO do software do veículo',
        controller_name: 'Nome do controlador',
        hardware_number: 'Número de hardware',
        software_information_before_Refresh: 'Informações sobre o software antes da atualização',
        software_information_after_Refresh: 'Informações sobre o software após a atualização',
        write_software_information: 'Escrever informações sobre o software',
        function_name: 'Nome da função',
        minor_process_execution_time: 'Tempo de execução do processo menor',
        small_process_execution_result: 'Resultado da execução de um pequeno processo',
        function_execution_time: 'Tempo de execução da função',
        function_execution_result: 'Resultado da execução da função',
        function_execution_result_desp_zh: 'Descrição do resultado da execução da função (chinês)',
        function_execution_result_desp_en: 'Descrição do resultado da execução da função (inglês)',
        log_start_time: 'Hora de início do registo',
        log_end_time: 'Hora de fim do registo',
        vehicle_recognition_method: 'Método de reconhecimento do veículo',
        vehicle_recognition_method_desp_zh:
            'Descrição do método de reconhecimento do veículo (chinês)',
        vehicle_recognition_method_desp_en:
            'Descrição do método de reconhecimento do veículo (inglês)',
        model_year: 'Ano do modelo',
        vehicle_configuration_information: 'Informações de configuração do veículo',
        platform: 'Plataforma',
        login_account: 'Conta de início de sessão',
        user_name: 'Nome de utilizador',
        service_center: 'Centro de serviço',
        SIPS_version: 'Versão SIPS',
        VDI_version: 'Versão VDI',
        VDI_connection_method: 'Método de ligação VDI',
        VDI_connection_method_desp_zh: 'Descrição do método de ligação VDI (chinês)',
        VDI_connection_method_desp_en: 'Descrição da ligação VDI (inglês)',
        operating_system: 'Sistema operativo',
        operating_system_zh: 'Sistema operativo (chinês)',
        operating_system_en: 'Sistema operativo (inglês)',
        brand: 'Marca',
        country_region: 'País/Região',
    },
    // 波兰
    plPL: {
        model: 'Model',
        mileage: 'Przebieg',
        functiontype: 'Typ funkcji',
        functiontypedesp_zh: 'Opis typu funkcji (chiński)',
        functiontypedesp_en: 'Opis typu funkcji (angielski)',
        channel: 'Kanał',
        channeldesp_zh: 'Opis kanału (chiński)',
        channeldesp_en: 'Opis kanału (angielski)',
        functionstarttime: 'Czas rozpoczęcia funkcji',
        OS_version_beforere_freshing:
            'Wersja systemu operacyjnego oprogramowania pojazdu przed odświeżeniem',
        part_number_before_refreshing: 'Numer części oprogramowania pojazdu przed odświeżeniem',
        vehicle_software_OS_version: 'Wersja systemu operacyjnego oprogramowania pojazdu',
        controller_name: 'Nazwa kontrolera',
        hardware_number: 'Numer sprzętu',
        software_information_before_Refresh: 'Informacje o oprogramowaniu przed odświeżeniem',
        software_information_after_Refresh: 'Informacje o oprogramowaniu po odświeżeniu',
        write_software_information: 'Zapisywanie informacji o oprogramowaniu',
        function_name: 'Nazwa funkcji',
        minor_process_execution_time: 'Czas wykonania mniejszego procesu',
        small_process_execution_result: 'Wynik wykonania małego procesu',
        function_execution_time: 'Czas wykonania funkcji',
        function_execution_result: 'Wynik wykonania funkcji',
        function_execution_result_desp_zh: 'Opis wyniku wykonania funkcji (chiński)',
        function_execution_result_desp_en: 'Opis wyniku wykonania funkcji (angielski)',
        log_start_time: 'Czas rozpoczęcia dziennika',
        log_end_time: 'Czas zakończenia dziennika',
        vehicle_recognition_method: 'Metoda rozpoznawania pojazdu',
        vehicle_recognition_method_desp_zh: 'Opis metody rozpoznawania pojazdu (chiński)',
        vehicle_recognition_method_desp_en: 'Opis metody rozpoznawania pojazdu (angielski)',
        model_year: 'Rok modelowy',
        vehicle_configuration_information: 'Informacje o konfiguracji pojazdu',
        platform: 'Platforma',
        login_account: 'Konto logowania',
        user_name: 'Nazwa użytkownika',
        service_center: 'Centrum serwisowe',
        SIPS_version: 'Wersja SIPS',
        VDI_version: 'Wersja VDI',
        VDI_connection_method: 'Metoda połączenia VDI',
        VDI_connection_method_desp_zh: 'Opis metody połączenia VDI (chiński)',
        VDI_connection_method_desp_en: 'Opis połączenia VDI (angielski)',
        operating_system: 'System operacyjny',
        operating_system_zh: 'System operacyjny (chiński)',
        operating_system_en: 'System operacyjny (angielski)',
        brand: 'Marka',
        country_region: 'Kraj/region',
    },
    // 土耳其
    trTR: {
        model: 'Model',
        mileage: 'Kilometre',
        functiontype: 'Fonksiyon Tipi',
        functiontypedesp_zh: 'İşlev Türü Açıklama (Çince)',
        functiontypedesp_en: 'Fonksiyon Tipi Açıklaması (İngilizce)',
        channel: 'Kanal',
        channeldesp_zh: 'Kanal Açıklaması (Çince)',
        channeldesp_en: 'Kanal Açıklaması (İngilizce)',
        functionstarttime: 'Fonksiyon Başlangıç Zamanı',
        OS_version_beforere_freshing: 'Yenilemeden önce araç yazılımı işletim sistemi sürümü',
        part_number_before_refreshing: 'Yenilemeden önce araç yazılımı parça numarası',
        vehicle_software_OS_version: 'Araç yazılımı OS sürümü',
        controller_name: 'Denetleyici Adı',
        hardware_number: 'Donanım numarası',
        software_information_before_Refresh: 'Yenilemeden Önce Yazılım Bilgileri',
        software_information_after_Refresh: 'Yenileme sonrası yazılım bilgileri',
        write_software_information: 'Yazılım Bilgilerini Yazın',
        function_name: 'İşlev adı',
        minor_process_execution_time: 'Minör işlem yürütme süresi',
        small_process_execution_result: 'Küçük işlem yürütme sonucu',
        function_execution_time: 'Fonksiyon yürütme süresi',
        function_execution_result: 'Fonksiyon Yürütme Sonucu',
        function_execution_result_desp_zh: 'Fonksiyon Yürütme Sonucu Açıklaması (Çince)',
        function_execution_result_desp_en: 'Fonksiyon Yürütme Sonuç Açıklaması (İngilizce)',
        log_start_time: 'Günlük başlangıç zamanı',
        log_end_time: 'Günlük bitiş zamanı',
        vehicle_recognition_method: 'Araç Tanıma Yöntemi',
        vehicle_recognition_method_desp_zh: 'Araç Tanıma Yöntemi Açıklaması (Çince)',
        vehicle_recognition_method_desp_en: 'Araç Tanıma Yöntemi Açıklaması (İngilizce)',
        model_year: 'Model Yılı',
        vehicle_configuration_information: 'Araç Konfigürasyon Bilgileri',
        platform: 'Platform',
        login_account: 'Giriş hesabı',
        user_name: 'Kullanıcı Adı',
        service_center: 'Hizmet Merkezi',
        SIPS_version: 'SIPS Versiyonu',
        VDI_version: 'VDI Sürümü',
        VDI_connection_method: 'VDI Bağlantı yöntemi',
        VDI_connection_method_desp_zh: 'VDI bağlantı yönteminin açıklaması (Çince)',
        VDI_connection_method_desp_en: 'VDI Bağlantı Açıklaması (İngilizce)',
        operating_system: 'İşletim Sistemi',
        operating_system_zh: 'İşletim Sistemi (Çince)',
        operating_system_en: 'İşletim Sistemi (İngilizce)',
        brand: 'Marka',
        country_region: 'Ülke/Bölge',
    },
    // 捷克语
    csCZ: {
        model: 'Model',
        mileage: 'Počet najetých kilometrů',
        functiontype: 'Typ funkce',
        functiontypedesp_zh: 'Popis typu funkce (čínsky)',
        functiontypedesp_en: 'Popis typu funkce (anglicky)',
        channel: 'Kanál',
        channeldesp_zh: 'Popis kanálu (čínsky)',
        channeldesp_en: 'Popis kanálu (anglicky)',
        functionstarttime: 'Čas začátku funkce',
        OS_version_beforere_freshing: 'OS verze před obnovením',
        part_number_before_refreshing: 'Číslo dílu před obnovením',
        vehicle_software_OS_version: 'OS verze softwaru vozidla',
        controller_name: 'Název ovladače',
        hardware_number: 'Číslo hardwaru',
        software_information_before_Refresh: 'Informace o softwaru před obnovením',
        software_information_after_Refresh: 'Informace o softwaru po obnovení',
        write_software_information: 'Informace o napsaném softwaru',
        function_name: 'Název funkce',
        minor_process_execution_time: 'Doba provádění menšího procesu',
        small_process_execution_result: 'Výsledek provádění menšího procesu',
        function_execution_time: 'Doba provádění funkce',
        function_execution_result: 'Výsledek provádění funkce',
        function_execution_result_desp_zh: 'Popis výsledku provádění funkce (čínsky)',
        function_execution_result_desp_en: 'Popis výsledku provádění funkce (anglicky)',
        log_start_time: 'Čas začátku logu',
        log_end_time: 'Čas ukončení logu',
        vehicle_recognition_method: 'Metoda rozpoznání vozidla',
        vehicle_recognition_method_desp_zh: 'Popis metody rozpoznání vozidla (čínsky)',
        vehicle_recognition_method_desp_en: 'Popis metody rozpoznání vozidla (anglicky)',
        model_year: 'Rok modelu',
        vehicle_configuration_information: 'Informace o konfiguraci vozidla',
        platform: 'Platforma',
        login_account: 'Přihlašovací účet',
        user_name: 'Uživatelské jméno',
        service_center: 'Servisní centrum',
        SIPS_version: 'Verze SIPS',
        VDI_version: 'Verze VDI',
        VDI_connection_method: 'Metoda připojení VDI',
        VDI_connection_method_desp_zh: 'Popis metody připojení VDI (čínsky)',
        VDI_connection_method_desp_en: 'Popis metody připojení VDI (anglicky)',
        operating_system: 'Operační systém',
        operating_system_zh: 'Operační systém (čínsky)',
        operating_system_en: 'Operační systém (anglicky)',
        brand: 'Značka',
        country_region: 'Země/region',
    },
    // 匈牙利语
    huHU: {
        model: 'Modell',
        mileage: 'Futásteljesítmény',
        functiontype: 'Funkciótípus',
        functiontypedesp_zh: 'Funkciótípus leírása (kínai)',
        functiontypedesp_en: 'Funkciótípus leírása (angol)',
        channel: 'Csatorna',
        channeldesp_zh: 'Csatorna leírása (kínai)',
        channeldesp_en: 'Csatorna leírása (angol)',
        functionstarttime: 'Funkció kezdési ideje',
        OS_version_beforere_freshing: 'Frissítés előtti szoftver OS verzió',
        part_number_before_refreshing: 'Frissítés előtti szoftver alkatrész száma',
        vehicle_software_OS_version: 'Jármű szoftver OS verzió',
        controller_name: 'Vezérlő neve',
        hardware_number: 'Hardver száma',
        software_information_before_Refresh: 'Frissítés előtti szoftverinformáció',
        software_information_after_Refresh: 'Frissített szoftverinformáció',
        write_software_information: 'Írásos szoftverinformáció',
        function_name: 'Funkció neve',
        minor_process_execution_time: 'Kis folyamat végrehajtási idő',
        small_process_execution_result: 'Kis folyamat végrehajtási eredmény',
        function_execution_time: 'Funkció végrehajtási idő',
        function_execution_result: 'Funkció végrehajtási eredmény',
        function_execution_result_desp_zh: 'Funkció végrehajtási eredmény leírása (kínai)',
        function_execution_result_desp_en: 'Funkció végrehajtási eredmény leírása (angol)',
        log_start_time: 'Log kezdési idő',
        log_end_time: 'Log befejezési idő',
        vehicle_recognition_method: 'Jármű azonosítási módszer',
        vehicle_recognition_method_desp_zh: 'Jármű azonosítási módszer leírása (kínai)',
        vehicle_recognition_method_desp_en: 'Jármű azonosítási módszer leírása (angol)',
        model_year: 'Évjárat',
        vehicle_configuration_information: 'Jármű konfigurációs információ',
        platform: 'Platform',
        login_account: 'Bejelentkezési fiók',
        user_name: 'Felhasználónév',
        service_center: 'Szervizközpont',
        SIPS_version: 'SIPS verzió',
        VDI_version: 'VDI verzió',
        VDI_connection_method: 'VDI kapcsolódási mód',
        VDI_connection_method_desp_zh: 'VDI kapcsolódási mód leírása (kínai)',
        VDI_connection_method_desp_en: 'VDI kapcsolódási mód leírása (angol)',
        operating_system: 'Operációs rendszer',
        operating_system_zh: 'Operációs rendszer (kínai)',
        operating_system_en: 'Operációs rendszer (angol)',
        brand: 'Márka',
        country_region: 'Ország/Region',
    },
    // 俄罗斯语
    ruRU: {
        model: 'Модель',
        mileage: 'Пробег',
        functiontype: 'Тип функции',
        functiontypedesp_zh: 'Описание типа функции (китайский)',
        functiontypedesp_en: 'Описание типа функции (английский)',
        channel: 'Канал',
        channeldesp_zh: 'Описание канала (китайский)',
        channeldesp_en: 'Описание канала (английский)',
        functionstarttime: 'Время начала функции',
        OS_version_beforere_freshing: 'Версия ОС программного обеспечения автомобиля до обновления',
        part_number_before_refreshing: 'Номер детали программного обеспечения до обновления',
        vehicle_software_OS_version: 'Версия ОС программного обеспечения',
        controller_name: 'Имя контроллера',
        hardware_number: 'Номер оборудования',
        software_information_before_Refresh: 'Информация о программном обеспечении до обновления',
        software_information_after_Refresh: 'Информация о программном обеспечении после обновления',
        write_software_information: 'Информация о программировании',
        function_name: 'Название функции',
        minor_process_execution_time: 'Время выполнения мелкого процесса',
        small_process_execution_result: 'Результат выполнения мелкого процесса',
        function_execution_time: 'Время выполнения функции',
        function_execution_result: 'Результат выполнения функции',
        function_execution_result_desp_zh: 'Описание результата выполнения функции (китайский)',
        function_execution_result_desp_en: 'Описание результата выполнения функции (английский)',
        log_start_time: 'Время начала журнала',
        log_end_time: 'Время окончания журнала',
        vehicle_recognition_method: 'Метод распознавания автомобиля',
        vehicle_recognition_method_desp_zh: 'Описание метода распознавания автомобиля (китайский)',
        vehicle_recognition_method_desp_en: 'Описание метода распознавания автомобиля (английский)',
        model_year: 'Год модели',
        vehicle_configuration_information: 'Информация о конфигурации автомобиля',
        platform: 'Платформа',
        login_account: 'Логин',
        user_name: 'Имя пользователя',
        service_center: 'Центр обслуживания',
        SIPS_version: 'Версия SIPS',
        VDI_version: 'Версия VDI',
        VDI_connection_method: 'Метод подключения VDI',
        VDI_connection_method_desp_zh: 'Описание метода подключения VDI (китайский)',
        VDI_connection_method_desp_en: 'Описание метода подключения VDI (английский)',
        operating_system: 'Операционная система',
        operating_system_zh: 'Операционная система (китайский)',
        operating_system_en: 'Операционная система (английский)',
        brand: 'Бренд',
        country_region: 'Страна/Регион',
    },
    // 沙特阿拉伯
    arSA: {
        model: 'طراز المركبة',
        mileage: 'عدد الكيلومترات',
        functiontype: 'نوع الوظيفة',
        functiontypedesp_zh: 'وصف نوع الوظيفة (بالصينية)',
        functiontypedesp_en: 'وصف نوع الوظيفة (بالإنجليزية)',
        channel: 'القناة',
        channeldesp_zh: 'وصف القناة (بالصينية)',
        channeldesp_en: 'وصف القناة (بالإنجليزية)',
        functionstarttime: 'وقت بدء الوظيفة',
        OS_version_beforere_freshing: 'إصدار نظام التشغيل قبل التحديث',
        part_number_before_refreshing: 'رقم القطعة قبل التحديث',
        vehicle_software_OS_version: 'إصدار نظام تشغيل برنامج المركبة',
        controller_name: 'اسم وحدة التحكم',
        hardware_number: 'رقم الجهاز',
        software_information_before_Refresh: 'معلومات البرنامج قبل التحديث',
        software_information_after_Refresh: 'معلومات البرنامج بعد التحديث',
        write_software_information: 'كتابة معلومات البرنامج',
        function_name: 'اسم الوظيفة',
        minor_process_execution_time: 'مدة تنفيذ العملية الفرعية',
        small_process_execution_result: 'نتيجة تنفيذ العملية الفرعية',
        function_execution_time: 'مدة تنفيذ الوظيفة',
        function_execution_result: 'نتيجة تنفيذ الوظيفة',
        function_execution_result_desp_zh: 'وصف نتيجة تنفيذ الوظيفة (بالصينية)',
        function_execution_result_desp_en: 'وصف نتيجة تنفيذ الوظيفة (بالإنجليزية)',
        log_start_time: 'وقت بدء السجل',
        log_end_time: 'وقت انتهاء السجل',
        vehicle_recognition_method: 'طريقة التعرف على المركبة',
        vehicle_recognition_method_desp_zh: 'وصف طريقة التعرف على المركبة (بالصينية)',
        vehicle_recognition_method_desp_en: 'وصف طريقة التعرف على المركبة (بالإنجليزية)',
        model_year: 'سنة الطراز',
        vehicle_configuration_information: 'معلومات تكوين المركبة',
        platform: 'المنصة',
        login_account: 'حساب تسجيل الدخول',
        user_name: 'اسم المستخدم',
        service_center: 'مركز الخدمة',
        SIPS_version: 'إصدار SIPS',
        VDI_version: 'إصدار VDI',
        VDI_connection_method: 'طريقة اتصال VDI',
        VDI_connection_method_desp_zh: 'وصف طريقة اتصال VDI (بالصينية)',
        VDI_connection_method_desp_en: 'وصف طريقة اتصال VDI (بالإنجليزية)',
        operating_system: 'نظام التشغيل',
        operating_system_zh: 'نظام التشغيل (بالصينية)',
        operating_system_en: 'نظام التشغيل (بالإنجليزية)',
        brand: 'العلامة التجارية',
        country_region: 'البلد/المنطقة',
    },
    // 保加利亚
    bgBG: {
        model: 'Модел',
        mileage: 'Пробег',
        functiontype: 'Тип функция',
        functiontypedesp_zh: 'Описание на типа функция (на китайски)',
        functiontypedesp_en: 'Описание на типа функция (на английски)',
        channel: 'Канал',
        channeldesp_zh: 'Описание на канала (на китайски)',
        channeldesp_en: 'Описание на канала (на английски)',
        functionstarttime: 'Начално време на функцията',
        OS_version_beforere_freshing: 'Версия на ОС преди актуализация',
        part_number_before_refreshing: 'Номер на част преди актуализация',
        vehicle_software_OS_version: 'Версия на ОС на софтуера за превозното средство',
        controller_name: 'Име на контролер',
        hardware_number: 'Хардуерен номер',
        software_information_before_Refresh: 'Софтуерна информация преди актуализация',
        software_information_after_Refresh: 'Софтуерна информация след актуализация',
        write_software_information: 'Записана софтуерна информация',
        function_name: 'Име на функцията',
        minor_process_execution_time: 'Продължителност на малкия процес',
        small_process_execution_result: 'Резултат от изпълнението на малкия процес',
        function_execution_time: 'Продължителност на изпълнението на функцията',
        function_execution_result: 'Резултат от изпълнението на функцията',
        function_execution_result_desp_zh: 'Описание на резултата (на китайски)',
        function_execution_result_desp_en: 'Описание на резултата (на английски)',
        log_start_time: 'Начално време на дневника',
        log_end_time: 'Крайно време на дневника',
        vehicle_recognition_method: 'Метод за разпознаване на превозното средство',
        vehicle_recognition_method_desp_zh: 'Описание на метода (на китайски)',
        vehicle_recognition_method_desp_en: 'Описание на метода (на английски)',
        model_year: 'Година на модела',
        vehicle_configuration_information: 'Информация за конфигурацията на превозното средство',
        platform: 'Платформа',
        login_account: 'Акаунт за вход',
        user_name: 'Потребителско име',
        service_center: 'Сервизен център',
        SIPS_version: 'Версия на SIPS',
        VDI_version: 'Версия на VDI',
        VDI_connection_method: 'Метод за връзка с VDI',
        VDI_connection_method_desp_zh: 'Описание на метода за връзка с VDI (на китайски)',
        VDI_connection_method_desp_en: 'Описание на метода за връзка с VDI (на английски)',
        operating_system: 'Операционна система',
        operating_system_zh: 'Операционна система (на китайски)',
        operating_system_en: 'Операционна система (на английски)',
        brand: 'Марка',
        country_region: 'Държава/регион',
    },
    // 丹麦语
    daDK: {
        model: 'Model',
        mileage: 'Kilometertal',
        functiontype: 'Funktionstype',
        functiontypedesp_zh: 'Beskrivelse af funktionstype (kinesisk)',
        functiontypedesp_en: 'Beskrivelse af funktionstype (engelsk)',
        channel: 'Kanal',
        channeldesp_zh: 'Kanalbeskrivelse (kinesisk)',
        channeldesp_en: 'Kanalbeskrivelse (engelsk)',
        functionstarttime: 'Funktionsstarttidspunkt',
        OS_version_beforere_freshing: 'OS-version før opdatering',
        part_number_before_refreshing: 'Reservedelsnummer før opdatering',
        vehicle_software_OS_version: 'Køretøjets software-OS-version',
        controller_name: 'Styringsenhedens navn',
        hardware_number: 'Hardwarenummer',
        software_information_before_Refresh: 'Softwareinformation før opdatering',
        software_information_after_Refresh: 'Softwareinformation efter opdatering',
        write_software_information: 'Skriv softwareinformation',
        function_name: 'Funktionsnavn',
        minor_process_execution_time: 'Udførelsestid for delproces',
        small_process_execution_result: 'Resultat af delproces',
        function_execution_time: 'Funktionsudførelsestid',
        function_execution_result: 'Resultat af funktionsudførelse',
        function_execution_result_desp_zh: 'Beskrivelse af resultat (kinesisk)',
        function_execution_result_desp_en: 'Beskrivelse af resultat (engelsk)',
        log_start_time: 'Logstarttidspunkt',
        log_end_time: 'Logsluttidspunkt',
        vehicle_recognition_method: 'Køretøjsgenkendelsesmetode',
        vehicle_recognition_method_desp_zh: 'Beskrivelse af genkendelsesmetode (kinesisk)',
        vehicle_recognition_method_desp_en: 'Beskrivelse af genkendelsesmetode (engelsk)',
        model_year: 'Modelår',
        vehicle_configuration_information: 'Køretøjskonfigurationsoplysninger',
        platform: 'Platform',
        login_account: 'Login-konto',
        user_name: 'Brugernavn',
        service_center: 'Servicecenter',
        SIPS_version: 'SIPS-version',
        VDI_version: 'VDI-version',
        VDI_connection_method: 'VDI-forbindelsesmetode',
        VDI_connection_method_desp_zh: 'Beskrivelse af VDI-forbindelse (kinesisk)',
        VDI_connection_method_desp_en: 'Beskrivelse af VDI-forbindelse (engelsk)',
        operating_system: 'Operativsystem',
        operating_system_zh: 'Operativsystem (kinesisk)',
        operating_system_en: 'Operativsystem (engelsk)',
        brand: 'Mærke',
        country_region: 'Land/region',
    },
    // 芬兰语
    fiFI: {
        model: 'Malli',
        mileage: 'Ajokilometrit',
        functiontype: 'Toiminnon tyyppi',
        functiontypedesp_zh: 'Toimintotyypin kuvaus (kiinaksi)',
        functiontypedesp_en: 'Toimintotyypin kuvaus (englanniksi)',
        channel: 'Kanava',
        channeldesp_zh: 'Kanavan kuvaus (kiinaksi)',
        channeldesp_en: 'Kanavan kuvaus (englanniksi)',
        functionstarttime: 'Toiminnon aloitusaika',
        OS_version_beforere_freshing: 'Käyttöjärjestelmän versio ennen päivitystä',
        part_number_before_refreshing: 'Osanumero ennen päivitystä',
        vehicle_software_OS_version: 'Ajoneuvon ohjelmiston käyttöjärjestelmäversio',
        controller_name: 'Ohjaimen nimi',
        hardware_number: 'Laitenro',
        software_information_before_Refresh: 'Ohjelmistotieto ennen päivitystä',
        software_information_after_Refresh: 'Ohjelmistotieto päivityksen jälkeen',
        write_software_information: 'Kirjoita ohjelmistotieto',
        function_name: 'Toiminnon nimi',
        minor_process_execution_time: 'Pieni prosessin suoritusaika',
        small_process_execution_result: 'Pienen prosessin suoritustulos',
        function_execution_time: 'Toiminnon suoritusaika',
        function_execution_result: 'Toiminnon suoritustulos',
        function_execution_result_desp_zh: 'Suoritustuloksen kuvaus (kiinaksi)',
        function_execution_result_desp_en: 'Suoritustuloksen kuvaus (englanniksi)',
        log_start_time: 'Lokin aloitusaika',
        log_end_time: 'Lokin lopetusaika',
        vehicle_recognition_method: 'Ajoneuvon tunnistustapa',
        vehicle_recognition_method_desp_zh: 'Tunnistustavan kuvaus (kiinaksi)',
        vehicle_recognition_method_desp_en: 'Tunnistustavan kuvaus (englanniksi)',
        model_year: 'Mallivuosi',
        vehicle_configuration_information: 'Ajoneuvon määritystiedot',
        platform: 'Alusta',
        login_account: 'Kirjautumistili',
        user_name: 'Käyttäjänimi',
        service_center: 'Huoltokeskus',
        SIPS_version: 'SIPS-versio',
        VDI_version: 'VDI-versio',
        VDI_connection_method: 'VDI-yhteysmenetelmä',
        VDI_connection_method_desp_zh: 'VDI-yhteyden kuvaus (kiinaksi)',
        VDI_connection_method_desp_en: 'VDI-yhteyden kuvaus (englanniksi)',
        operating_system: 'Käyttöjärjestelmä',
        operating_system_zh: 'Käyttöjärjestelmä (kiinaksi)',
        operating_system_en: 'Käyttöjärjestelmä (englanniksi)',
        brand: 'Merkki',
        country_region: 'Maa/alue',
    },
    // 繁体中文台湾
    zhTW: {
        model: '車型',
        mileage: '里程數',
        functiontype: '功能類型',
        functiontypedesp_zh: '功能類型描述(中文)',
        functiontypedesp_en: '功能類型描述(英文)',
        channel: '通道',
        channeldesp_zh: '通道描述(中文)',
        channeldesp_en: '通道描述(英文)',
        functionstarttime: '功能開始時間',
        OS_version_beforere_freshing: '刷新前整車軟體OS版本',
        part_number_before_refreshing: '刷新前整車軟體零件號',
        vehicle_software_OS_version: '車軟體OS版本',
        controller_name: '控制器名稱',
        hardware_number: '硬體號',
        software_information_before_Refresh: '刷新前的軟體資訊',
        software_information_after_Refresh: '刷新後的軟體資訊',
        write_software_information: '寫入軟體資訊',
        function_name: '功能名',
        minor_process_execution_time: '小流程執行時長',
        small_process_execution_result: '小流程執行結果',
        function_execution_time: '功能執行時長',
        function_execution_result: '功能執行結果',
        function_execution_result_desp_zh: '功能執行結果描述(中文)',
        function_execution_result_desp_en: '功能執行結果描述(英文)',
        log_start_time: 'Log開始時間',
        log_end_time: 'Log結束時間',
        vehicle_recognition_method: '車輛識別方式',
        vehicle_recognition_method_desp_zh: '車輛識別方式描述(中文)',
        vehicle_recognition_method_desp_en: '車輛識別方式描述(英文)',
        model_year: '年款',
        vehicle_configuration_information: '車輛配置資訊',
        platform: '平台',
        login_account: '登入帳號',
        user_name: '用戶名稱',
        service_center: '服務中心',
        SIPS_version: 'SIPS版本',
        VDI_version: 'VDI版本',
        VDI_connection_method: 'VDI連接方式',
        VDI_connection_method_desp_zh: 'VDI連接方式描述(中文)',
        VDI_connection_method_desp_en: 'VDI連接方式描述(英文)',
        operating_system: '作業系統',
        operating_system_zh: '作業系統(中文)',
        operating_system_en: '作業系統(英文)',
        brand: '品牌',
        country_region: '國家/地區',
    },
    // 克罗地亚
    hrHR: {
        model: 'Model',
        mileage: 'Prijeđeni kilometri',
        functiontype: 'Vrsta funkcije',
        functiontypedesp_zh: 'Opis vrste funkcije (na kineskom)',
        functiontypedesp_en: 'Opis vrste funkcije (na engleskom)',
        channel: 'Kanal',
        channeldesp_zh: 'Opis kanala (na kineskom)',
        channeldesp_en: 'Opis kanala (na engleskom)',
        functionstarttime: 'Vrijeme početka funkcije',
        OS_version_beforere_freshing: 'Verzija OS-a prije osvježenja',
        part_number_before_refreshing: 'Broj dijela prije osvježenja',
        vehicle_software_OS_version: 'Verzija OS-a softvera vozila',
        controller_name: 'Naziv kontrolera',
        hardware_number: 'Hardverski broj',
        software_information_before_Refresh: 'Informacije o softveru prije osvježenja',
        software_information_after_Refresh: 'Informacije o softveru nakon osvježenja',
        write_software_information: 'Zapisane informacije o softveru',
        function_name: 'Naziv funkcije',
        minor_process_execution_time: 'Trajanje izvođenja manjeg procesa',
        small_process_execution_result: 'Rezultat izvođenja manjeg procesa',
        function_execution_time: 'Trajanje izvođenja funkcije',
        function_execution_result: 'Rezultat izvođenja funkcije',
        function_execution_result_desp_zh: 'Opis rezultata (na kineskom)',
        function_execution_result_desp_en: 'Opis rezultata (na engleskom)',
        log_start_time: 'Vrijeme početka zapisnika',
        log_end_time: 'Vrijeme završetka zapisnika',
        vehicle_recognition_method: 'Način prepoznavanja vozila',
        vehicle_recognition_method_desp_zh: 'Opis načina prepoznavanja (na kineskom)',
        vehicle_recognition_method_desp_en: 'Opis načina prepoznavanja (na engleskom)',
        model_year: 'Godina modela',
        vehicle_configuration_information: 'Informacije o konfiguraciji vozila',
        platform: 'Platforma',
        login_account: 'Korisnički račun',
        user_name: 'Korisničko ime',
        service_center: 'Servisni centar',
        SIPS_version: 'Verzija SIPS-a',
        VDI_version: 'Verzija VDI-ja',
        VDI_connection_method: 'Način povezivanja s VDI-jem',
        VDI_connection_method_desp_zh: 'Opis načina povezivanja s VDI-jem (na kineskom)',
        VDI_connection_method_desp_en: 'Opis načina povezivanja s VDI-jem (na engleskom)',
        operating_system: 'Operativni sustav',
        operating_system_zh: 'Operativni sustav (na kineskom)',
        operating_system_en: 'Operativni sustav (na engleskom)',
        brand: 'Marka',
        country_region: 'Država/regija',
    },
    // 拉脱维亚
    lvLV: {
        model: 'Modelis',
        mileage: 'Nobraukums',
        functiontype: 'Funkcijas veids',
        functiontypedesp_zh: 'Funkcijas veida apraksts (ķīniešu valodā)',
        functiontypedesp_en: 'Funkcijas veida apraksts (angļu valodā)',
        channel: 'Kanāls',
        channeldesp_zh: 'Kanāla apraksts (ķīniešu valodā)',
        channeldesp_en: 'Kanāla apraksts (angļu valodā)',
        functionstarttime: 'Funkcijas sākuma laiks',
        OS_version_beforere_freshing: 'OS versija pirms atjaunošanas',
        part_number_before_refreshing: 'Detaļas numurs pirms atjaunošanas',
        vehicle_software_OS_version: 'Transportlīdzekļa programmatūras OS versija',
        controller_name: 'Kontrolētāja nosaukums',
        hardware_number: 'Aparatūras numurs',
        software_information_before_Refresh: 'Programmatūras informācija pirms atjaunošanas',
        software_information_after_Refresh: 'Programmatūras informācija pēc atjaunošanas',
        write_software_information: 'Ierakstītā programmatūras informācija',
        function_name: 'Funkcijas nosaukums',
        minor_process_execution_time: 'Mazā procesa izpildes ilgums',
        small_process_execution_result: 'Mazā procesa izpildes rezultāts',
        function_execution_time: 'Funkcijas izpildes ilgums',
        function_execution_result: 'Funkcijas izpildes rezultāts',
        function_execution_result_desp_zh: 'Rezultāta apraksts (ķīniešu valodā)',
        function_execution_result_desp_en: 'Rezultāta apraksts (angļu valodā)',
        log_start_time: 'Žurnāla sākuma laiks',
        log_end_time: 'Žurnāla beigu laiks',
        vehicle_recognition_method: 'Transportlīdzekļa atpazīšanas metode',
        vehicle_recognition_method_desp_zh: 'Atzīšanas metodes apraksts (ķīniešu valodā)',
        vehicle_recognition_method_desp_en: 'Atzīšanas metodes apraksts (angļu valodā)',
        model_year: 'Modeļa gads',
        vehicle_configuration_information: 'Transportlīdzekļa konfigurācijas informācija',
        platform: 'Platforma',
        login_account: 'Pieteikšanās konts',
        user_name: 'Lietotājvārds',
        service_center: 'Apkalpošanas centrs',
        SIPS_version: 'SIPS versija',
        VDI_version: 'VDI versija',
        VDI_connection_method: 'VDI savienojuma metode',
        VDI_connection_method_desp_zh: 'VDI savienojuma apraksts (ķīniešu valodā)',
        VDI_connection_method_desp_en: 'VDI savienojuma apraksts (angļu valodā)',
        operating_system: 'Operētājsistēma',
        operating_system_zh: 'Operētājsistēma (ķīniešu valodā)',
        operating_system_en: 'Operētājsistēma (angļu valodā)',
        brand: 'Zīmols',
        country_region: 'Valsts/reģions',
    },
    // 立陶宛
    ltLT: {
        model: 'Modelis',
        mileage: 'Rida',
        functiontype: 'Funkcijos tipas',
        functiontypedesp_zh: 'Funkcijos tipo aprašas (kinų kalba)',
        functiontypedesp_en: 'Funkcijos tipo aprašas (anglų kalba)',
        channel: 'Kanalas',
        channeldesp_zh: 'Kanalo aprašas (kinų kalba)',
        channeldesp_en: 'Kanalo aprašas (anglų kalba)',
        functionstarttime: 'Funkcijos pradžios laikas',
        OS_version_beforere_freshing: 'OS versija prieš atnaujinimą',
        part_number_before_refreshing: 'Detalės numeris prieš atnaujinimą',
        vehicle_software_OS_version: 'Transporto priemonės programinės įrangos OS versija',
        controller_name: 'Valdiklio pavadinimas',
        hardware_number: 'Aparatinės įrangos numeris',
        software_information_before_Refresh: 'Programinės įrangos informacija prieš atnaujinimą',
        software_information_after_Refresh: 'Programinės įrangos informacija po atnaujinimo',
        write_software_information: 'Įrašyta programinės įrangos informacija',
        function_name: 'Funkcijos pavadinimas',
        minor_process_execution_time: 'Mažo proceso vykdymo trukmė',
        small_process_execution_result: 'Mažo proceso vykdymo rezultatas',
        function_execution_time: 'Funkcijos vykdymo trukmė',
        function_execution_result: 'Funkcijos vykdymo rezultatas',
        function_execution_result_desp_zh: 'Rezultato aprašas (kinų kalba)',
        function_execution_result_desp_en: 'Rezultato aprašas (anglų kalba)',
        log_start_time: 'Žurnalo pradžios laikas',
        log_end_time: 'Žurnalo pabaigos laikas',
        vehicle_recognition_method: 'Transporto priemonės atpažinimo būdas',
        vehicle_recognition_method_desp_zh: 'Atpažinimo būdo aprašas (kinų kalba)',
        vehicle_recognition_method_desp_en: 'Atpažinimo būdo aprašas (anglų kalba)',
        model_year: 'Modelio metai',
        vehicle_configuration_information: 'Transporto priemonės konfigūracijos informacija',
        platform: 'Platforma',
        login_account: 'Prisijungimo paskyra',
        user_name: 'Vartotojo vardas',
        service_center: 'Aptarnavimo centras',
        SIPS_version: 'SIPS versija',
        VDI_version: 'VDI versija',
        VDI_connection_method: 'VDI ryšio būdas',
        VDI_connection_method_desp_zh: 'VDI ryšio būdo aprašas (kinų kalba)',
        VDI_connection_method_desp_en: 'VDI ryšio būdo aprašas (anglų kalba)',
        operating_system: 'Operacinė sistema',
        operating_system_zh: 'Operacinė sistema (kinų kalba)',
        operating_system_en: 'Operacinė sistema (anglų kalba)',
        brand: 'Prekės ženklas',
        country_region: 'Šalis/regionas',
    },
    // 罗马尼亚
    roRO: {
        model: 'Model',
        mileage: 'Kilometraj',
        functiontype: 'Tip funcție',
        functiontypedesp_zh: 'Descriere tip funcție (chineză)',
        functiontypedesp_en: 'Descriere tip funcție (engleză)',
        channel: 'Canal',
        channeldesp_zh: 'Descriere canal (chineză)',
        channeldesp_en: 'Descriere canal (engleză)',
        functionstarttime: 'Timp start funcție',
        OS_version_beforere_freshing: 'Versiune OS înainte de actualizare',
        part_number_before_refreshing: 'Număr piesă înainte de actualizare',
        vehicle_software_OS_version: 'Versiune OS software vehicul',
        controller_name: 'Numele controlerului',
        hardware_number: 'Număr hardware',
        software_information_before_Refresh: 'Informații software înainte de actualizare',
        software_information_after_Refresh: 'Informații software după actualizare',
        write_software_information: 'Informații software scrise',
        function_name: 'Nume funcție',
        minor_process_execution_time: 'Durată execuție proces minor',
        small_process_execution_result: 'Rezultat execuție proces minor',
        function_execution_time: 'Durată execuție funcție',
        function_execution_result: 'Rezultat execuție funcție',
        function_execution_result_desp_zh: 'Descriere rezultat (chineză)',
        function_execution_result_desp_en: 'Descriere rezultat (engleză)',
        log_start_time: 'Timp început jurnal',
        log_end_time: 'Timp sfârșit jurnal',
        vehicle_recognition_method: 'Metodă recunoaștere vehicul',
        vehicle_recognition_method_desp_zh: 'Descriere metodă (chineză)',
        vehicle_recognition_method_desp_en: 'Descriere metodă (engleză)',
        model_year: 'An model',
        vehicle_configuration_information: 'Informații configurație vehicul',
        platform: 'Platformă',
        login_account: 'Cont de conectare',
        user_name: 'Nume utilizator',
        service_center: 'Centru de service',
        SIPS_version: 'Versiune SIPS',
        VDI_version: 'Versiune VDI',
        VDI_connection_method: 'Metodă conexiune VDI',
        VDI_connection_method_desp_zh: 'Descriere metodă VDI (chineză)',
        VDI_connection_method_desp_en: 'Descriere metodă VDI (engleză)',
        operating_system: 'Sistem de operare',
        operating_system_zh: 'Sistem de operare (chineză)',
        operating_system_en: 'Sistem de operare (engleză)',
        brand: 'Marcă',
        country_region: 'Țară/regiune',
    },
    // 挪威博克马尔
    nbNO: {
        model: 'Modell',
        mileage: 'Kilometerstand',
        functiontype: 'Funksjonstype',
        functiontypedesp_zh: 'Beskrivelse av funksjonstype (kinesisk)',
        functiontypedesp_en: 'Beskrivelse av funksjonstype (engelsk)',
        channel: 'Kanal',
        channeldesp_zh: 'Kanalbeskrivelse (kinesisk)',
        channeldesp_en: 'Kanalbeskrivelse (engelsk)',
        functionstarttime: 'Starttidspunkt for funksjon',
        OS_version_beforere_freshing: 'OS-versjon før oppdatering',
        part_number_before_refreshing: 'Delenummer før oppdatering',
        vehicle_software_OS_version: 'Kjøretøyprogramvarens OS-versjon',
        controller_name: 'Kontrollernavn',
        hardware_number: 'Maskinvarenr.',
        software_information_before_Refresh: 'Programvareinformasjon før oppdatering',
        software_information_after_Refresh: 'Programvareinformasjon etter oppdatering',
        write_software_information: 'Innskrevet programvareinformasjon',
        function_name: 'Funksjonsnavn',
        minor_process_execution_time: 'Kjøretid for delprosess',
        small_process_execution_result: 'Resultat av delprosess',
        function_execution_time: 'Funksjonskjøretid',
        function_execution_result: 'Resultat av funksjonsutførelse',
        function_execution_result_desp_zh: 'Resultatbeskrivelse (kinesisk)',
        function_execution_result_desp_en: 'Resultatbeskrivelse (engelsk)',
        log_start_time: 'Logg starttidspunkt',
        log_end_time: 'Logg sluttidspunkt',
        vehicle_recognition_method: 'Kjøretøyidentifiseringsmetode',
        vehicle_recognition_method_desp_zh: 'Beskrivelse av identifiseringsmetode (kinesisk)',
        vehicle_recognition_method_desp_en: 'Beskrivelse av identifiseringsmetode (engelsk)',
        model_year: 'Modellår',
        vehicle_configuration_information: 'Kjøretøykonfigurasjonsinformasjon',
        platform: 'Plattform',
        login_account: 'Påloggingskonto',
        user_name: 'Brukernavn',
        service_center: 'Servicecenter',
        SIPS_version: 'SIPS-versjon',
        VDI_version: 'VDI-versjon',
        VDI_connection_method: 'VDI-tilkoblingsmetode',
        VDI_connection_method_desp_zh: 'Beskrivelse av VDI-tilkobling (kinesisk)',
        VDI_connection_method_desp_en: 'Beskrivelse av VDI-tilkobling (engelsk)',
        operating_system: 'Operativsystem',
        operating_system_zh: 'Operativsystem (kinesisk)',
        operating_system_en: 'Operativsystem (engelsk)',
        brand: 'Merke',
        country_region: 'Land/region',
    },
    // 葡萄牙语巴西
    ptBX: {
        model: 'Modelo',
        mileage: 'Quilometragem',
        functiontype: 'Tipo de função',
        functiontypedesp_zh: 'Descrição do tipo de função (chinês)',
        functiontypedesp_en: 'Descrição do tipo de função (inglês)',
        channel: 'Canal',
        channeldesp_zh: 'Descrição do canal (chinês)',
        channeldesp_en: 'Descrição do canal (inglês)',
        functionstarttime: 'Horário de início da função',
        OS_version_beforere_freshing: 'Versão do SO antes da atualização',
        part_number_before_refreshing: 'Número da peça antes da atualização',
        vehicle_software_OS_version: 'Versão do SO do software do veículo',
        controller_name: 'Nome do controlador',
        hardware_number: 'Número do hardware',
        software_information_before_Refresh: 'Informações do software antes da atualização',
        software_information_after_Refresh: 'Informações do software após a atualização',
        write_software_information: 'Informações do software gravadas',
        function_name: 'Nome da função',
        minor_process_execution_time: 'Duração da execução do subprocesso',
        small_process_execution_result: 'Resultado da execução do subprocesso',
        function_execution_time: 'Duração da execução da função',
        function_execution_result: 'Resultado da execução da função',
        function_execution_result_desp_zh: 'Descrição do resultado (chinês)',
        function_execution_result_desp_en: 'Descrição do resultado (inglês)',
        log_start_time: 'Horário de início do log',
        log_end_time: 'Horário de término do log',
        vehicle_recognition_method: 'Método de reconhecimento do veículo',
        vehicle_recognition_method_desp_zh: 'Descrição do método (chinês)',
        vehicle_recognition_method_desp_en: 'Descrição do método (inglês)',
        model_year: 'Ano do modelo',
        vehicle_configuration_information: 'Informações de configuração do veículo',
        platform: 'Plataforma',
        login_account: 'Conta de login',
        user_name: 'Nome do usuário',
        service_center: 'Centro de serviço',
        SIPS_version: 'Versão do SIPS',
        VDI_version: 'Versão do VDI',
        VDI_connection_method: 'Método de conexão VDI',
        VDI_connection_method_desp_zh: 'Descrição do método de conexão VDI (chinês)',
        VDI_connection_method_desp_en: 'Descrição do método de conexão VDI (inglês)',
        operating_system: 'Sistema operacional',
        operating_system_zh: 'Sistema operacional (chinês)',
        operating_system_en: 'Sistema operacional (inglês)',
        brand: 'Marca',
        country_region: 'País/região',
    },
    // 瑞典语
    svSE: {
        model: 'Modell',
        mileage: 'Mätarställning',
        functiontype: 'Funktionstyp',
        functiontypedesp_zh: 'Beskrivning av funktionstyp (kinesiska)',
        functiontypedesp_en: 'Beskrivning av funktionstyp (engelska)',
        channel: 'Kanal',
        channeldesp_zh: 'Kanalbeskrivning (kinesiska)',
        channeldesp_en: 'Kanalbeskrivning (engelska)',
        functionstarttime: 'Funktionens starttid',
        OS_version_beforere_freshing: 'OS-version före uppdatering',
        part_number_before_refreshing: 'Reservdelsnummer före uppdatering',
        vehicle_software_OS_version: 'Fordonsmjukvarans OS-version',
        controller_name: 'Styrenhetsnamn',
        hardware_number: 'Hårdvarunummer',
        software_information_before_Refresh: 'Programvaruinformation före uppdatering',
        software_information_after_Refresh: 'Programvaruinformation efter uppdatering',
        write_software_information: 'Inskriven programvaruinformation',
        function_name: 'Funktionsnamn',
        minor_process_execution_time: 'Exekveringstid för delprocess',
        small_process_execution_result: 'Resultat av delprocess',
        function_execution_time: 'Funktionens exekveringstid',
        function_execution_result: 'Resultat av funktionskörning',
        function_execution_result_desp_zh: 'Resultatbeskrivning (kinesiska)',
        function_execution_result_desp_en: 'Resultatbeskrivning (engelska)',
        log_start_time: 'Loggstarttid',
        log_end_time: 'Loggsluttid',
        vehicle_recognition_method: 'Fordonsigenkänningsmetod',
        vehicle_recognition_method_desp_zh: 'Beskrivning av igenkänningsmetod (kinesiska)',
        vehicle_recognition_method_desp_en: 'Beskrivning av igenkänningsmetod (engelska)',
        model_year: 'Modellår',
        vehicle_configuration_information: 'Fordonskonfigurationsinformation',
        platform: 'Plattform',
        login_account: 'Inloggningskonto',
        user_name: 'Användarnamn',
        service_center: 'Servicecenter',
        SIPS_version: 'SIPS-version',
        VDI_version: 'VDI-version',
        VDI_connection_method: 'VDI-anslutningsmetod',
        VDI_connection_method_desp_zh: 'Beskrivning av VDI-anslutning (kinesiska)',
        VDI_connection_method_desp_en: 'Beskrivning av VDI-anslutning (engelska)',
        operating_system: 'Operativsystem',
        operating_system_zh: 'Operativsystem (kinesiska)',
        operating_system_en: 'Operativsystem (engelska)',
        brand: 'Märke',
        country_region: 'Land/region',
    },
    // 斯洛伐克
    skSK: {
        model: 'Model',
        mileage: 'Najazdené km',
        functiontype: 'Typ funkcie',
        functiontypedesp_zh: 'Popis typu funkcie (čínsky)',
        functiontypedesp_en: 'Popis typu funkcie (anglicky)',
        channel: 'Kanál',
        channeldesp_zh: 'Popis kanála (čínsky)',
        channeldesp_en: 'Popis kanála (anglicky)',
        functionstarttime: 'Čas spustenia funkcie',
        OS_version_beforere_freshing: 'Verzia OS pred aktualizáciou',
        part_number_before_refreshing: 'Číslo súčiastky pred aktualizáciou',
        vehicle_software_OS_version: 'Verzia OS softvéru vozidla',
        controller_name: 'Názov riadiacej jednotky',
        hardware_number: 'Hardvérové číslo',
        software_information_before_Refresh: 'Informácie o softvéri pred aktualizáciou',
        software_information_after_Refresh: 'Informácie o softvéri po aktualizácii',
        write_software_information: 'Zapísané informácie o softvéri',
        function_name: 'Názov funkcie',
        minor_process_execution_time: 'Trvanie vykonania drobného procesu',
        small_process_execution_result: 'Výsledok vykonania drobného procesu',
        function_execution_time: 'Trvanie vykonania funkcie',
        function_execution_result: 'Výsledok vykonania funkcie',
        function_execution_result_desp_zh: 'Popis výsledku (čínsky)',
        function_execution_result_desp_en: 'Popis výsledku (anglicky)',
        log_start_time: 'Čas začiatku denníka',
        log_end_time: 'Čas konca denníka',
        vehicle_recognition_method: 'Spôsob rozpoznania vozidla',
        vehicle_recognition_method_desp_zh: 'Popis spôsobu rozpoznania (čínsky)',
        vehicle_recognition_method_desp_en: 'Popis spôsobu rozpoznania (anglicky)',
        model_year: 'Rok modelu',
        vehicle_configuration_information: 'Informácie o konfigurácii vozidla',
        platform: 'Platforma',
        login_account: 'Prihlasovací účet',
        user_name: 'Meno používateľa',
        service_center: 'Servisné stredisko',
        SIPS_version: 'Verzia SIPS',
        VDI_version: 'Verzia VDI',
        VDI_connection_method: 'Spôsob pripojenia VDI',
        VDI_connection_method_desp_zh: 'Popis spôsobu pripojenia VDI (čínsky)',
        VDI_connection_method_desp_en: 'Popis spôsobu pripojenia VDI (anglicky)',
        operating_system: 'Operačný systém',
        operating_system_zh: 'Operačný systém (čínsky)',
        operating_system_en: 'Operačný systém (anglicky)',
        brand: 'Značka',
        country_region: 'Krajina/región',
    },
    // 斯洛文尼亚
    slSI: {
        model: 'Model',
        mileage: 'Prevoženi kilometri',
        functiontype: 'Vrsta funkcije',
        functiontypedesp_zh: 'Opis vrste funkcije (kitajsko)',
        functiontypedesp_en: 'Opis vrste funkcije (angleško)',
        channel: 'Kanal',
        channeldesp_zh: 'Opis kanala (kitajsko)',
        channeldesp_en: 'Opis kanala (angleško)',
        functionstarttime: 'Čas začetka funkcije',
        OS_version_beforere_freshing: 'Različica OS pred osvežitvijo',
        part_number_before_refreshing: 'Številka dela pred osvežitvijo',
        vehicle_software_OS_version: 'Različica OS programske opreme vozila',
        controller_name: 'Ime krmilnika',
        hardware_number: 'Številka strojne opreme',
        software_information_before_Refresh: 'Programske informacije pred osvežitvijo',
        software_information_after_Refresh: 'Programske informacije po osvežitvi',
        write_software_information: 'Zapisane programske informacije',
        function_name: 'Ime funkcije',
        minor_process_execution_time: 'Trajanje izvajanja malega postopka',
        small_process_execution_result: 'Rezultat izvajanja malega postopka',
        function_execution_time: 'Trajanje izvajanja funkcije',
        function_execution_result: 'Rezultat izvajanja funkcije',
        function_execution_result_desp_zh: 'Opis rezultata (kitajsko)',
        function_execution_result_desp_en: 'Opis rezultata (angleško)',
        log_start_time: 'Čas začetka dnevnika',
        log_end_time: 'Čas konca dnevnika',
        vehicle_recognition_method: 'Način prepoznavanja vozila',
        vehicle_recognition_method_desp_zh: 'Opis načina prepoznavanja (kitajsko)',
        vehicle_recognition_method_desp_en: 'Opis načina prepoznavanja (angleško)',
        model_year: 'Letnik modela',
        vehicle_configuration_information: 'Informacije o konfiguraciji vozila',
        platform: 'Platforma',
        login_account: 'Prijavni račun',
        user_name: 'Uporabniško ime',
        service_center: 'Servisni center',
        SIPS_version: 'Različica SIPS',
        VDI_version: 'Različica VDI',
        VDI_connection_method: 'Način povezave VDI',
        VDI_connection_method_desp_zh: 'Opis načina povezave VDI (kitajsko)',
        VDI_connection_method_desp_en: 'Opis načina povezave VDI (angleško)',
        operating_system: 'Operacijski sistem',
        operating_system_zh: 'Operacijski sistem (kitajsko)',
        operating_system_en: 'Operacijski sistem (angleško)',
        brand: 'Znamka',
        country_region: 'Država/regija',
    },
    // 泰语
    thTH: {
        model: 'รุ่นรถ',
        mileage: 'เลขไมล์',
        functiontype: 'ประเภทฟังก์ชัน',
        functiontypedesp_zh: 'คำอธิบายประเภทฟังก์ชัน (ภาษาจีน)',
        functiontypedesp_en: 'คำอธิบายประเภทฟังก์ชัน (ภาษาอังกฤษ)',
        channel: 'ช่องทาง',
        channeldesp_zh: 'คำอธิบายช่องทาง (ภาษาจีน)',
        channeldesp_en: 'คำอธิบายช่องทาง (ภาษาอังกฤษ)',
        functionstarttime: 'เวลาเริ่มต้นฟังก์ชัน',
        OS_version_beforere_freshing: 'เวอร์ชัน OS ของซอฟต์แวร์รถก่อนรีเฟรช',
        part_number_before_refreshing: 'หมายเลขชิ้นส่วนซอฟต์แวร์รถก่อนรีเฟรช',
        vehicle_software_OS_version: 'เวอร์ชัน OS ของซอฟต์แวร์รถ',
        controller_name: 'ชื่อคอนโทรลเลอร์',
        hardware_number: 'หมายเลขฮาร์ดแวร์',
        software_information_before_Refresh: 'ข้อมูลซอฟต์แวร์ก่อนรีเฟรช',
        software_information_after_Refresh: 'ข้อมูลซอฟต์แวร์หลังรีเฟรช',
        write_software_information: 'ข้อมูลซอฟต์แวร์ที่เขียน',
        function_name: 'ชื่อฟังก์ชัน',
        minor_process_execution_time: 'ระยะเวลาดำเนินการกระบวนการย่อย',
        small_process_execution_result: 'ผลลัพธ์การดำเนินการกระบวนการย่อย',
        function_execution_time: 'ระยะเวลาดำเนินการฟังก์ชัน',
        function_execution_result: 'ผลลัพธ์การดำเนินการฟังก์ชัน',
        function_execution_result_desp_zh: 'คำอธิบายผลลัพธ์ (ภาษาจีน)',
        function_execution_result_desp_en: 'คำอธิบายผลลัพธ์ (ภาษาอังกฤษ)',
        log_start_time: 'เวลาเริ่มต้น Log',
        log_end_time: 'เวลาสิ้นสุด Log',
        vehicle_recognition_method: 'วิธีการระบุรถ',
        vehicle_recognition_method_desp_zh: 'คำอธิบายวิธีการระบุรถ (ภาษาจีน)',
        vehicle_recognition_method_desp_en: 'คำอธิบายวิธีการระบุรถ (ภาษาอังกฤษ)',
        model_year: 'ปีรุ่น',
        vehicle_configuration_information: 'ข้อมูลการกำหนดค่ารถ',
        platform: 'แพลตฟอร์ม',
        login_account: 'บัญชีเข้าสู่ระบบ',
        user_name: 'ชื่อผู้ใช้',
        service_center: 'ศูนย์บริการ',
        SIPS_version: 'เวอร์ชัน SIPS',
        VDI_version: 'เวอร์ชัน VDI',
        VDI_connection_method: 'วิธีเชื่อมต่อ VDI',
        VDI_connection_method_desp_zh: 'คำอธิบายวิธีเชื่อมต่อ VDI (ภาษาจีน)',
        VDI_connection_method_desp_en: 'คำอธิบายวิธีเชื่อมต่อ VDI (ภาษาอังกฤษ)',
        operating_system: 'ระบบปฏิบัติการ',
        operating_system_zh: 'ระบบปฏิบัติการ (ภาษาจีน)',
        operating_system_en: 'ระบบปฏิบัติการ (ภาษาอังกฤษ)',
        brand: 'แบรนด์',
        country_region: 'ประเทศ/ภูมิภาค',
    },
    // 乌克兰语
    ukUA: {
        model: 'Модель',
        mileage: 'Пробіг',
        functiontype: 'Тип функції',
        functiontypedesp_zh: 'Опис типу функції (китайською)',
        functiontypedesp_en: 'Опис типу функції (англійською)',
        channel: 'Канал',
        channeldesp_zh: 'Опис каналу (китайською)',
        channeldesp_en: 'Опис каналу (англійською)',
        functionstarttime: 'Час початку функції',
        OS_version_beforere_freshing: 'Версія ОС до оновлення',
        part_number_before_refreshing: 'Номер деталі до оновлення',
        vehicle_software_OS_version: 'Версія ОС програмного забезпечення автомобіля',
        controller_name: 'Назва контролера',
        hardware_number: 'Апаратний номер',
        software_information_before_Refresh: 'Інформація про ПЗ до оновлення',
        software_information_after_Refresh: 'Інформація про ПЗ після оновлення',
        write_software_information: 'Записана інформація про програмне забезпечення',
        function_name: 'Назва функції',
        minor_process_execution_time: 'Тривалість виконання дрібного процесу',
        small_process_execution_result: 'Результат виконання дрібного процесу',
        function_execution_time: 'Тривалість виконання функції',
        function_execution_result: 'Результат виконання функції',
        function_execution_result_desp_zh: 'Опис результату (китайською)',
        function_execution_result_desp_en: 'Опис результату (англійською)',
        log_start_time: 'Час початку журналу',
        log_end_time: 'Час завершення журналу',
        vehicle_recognition_method: 'Спосіб розпізнавання транспортного засобу',
        vehicle_recognition_method_desp_zh: 'Опис способу розпізнавання (китайською)',
        vehicle_recognition_method_desp_en: 'Опис способу розпізнавання (англійською)',
        model_year: 'Рік моделі',
        vehicle_configuration_information: 'Інформація про конфігурацію транспортного засобу',
        platform: 'Платформа',
        login_account: 'Обліковий запис',
        user_name: 'Ім’я користувача',
        service_center: 'Сервісний центр',
        SIPS_version: 'Версія SIPS',
        VDI_version: 'Версія VDI',
        VDI_connection_method: 'Спосіб підключення VDI',
        VDI_connection_method_desp_zh: 'Опис способу підключення VDI (китайською)',
        VDI_connection_method_desp_en: 'Опис способу підключення VDI (англійською)',
        operating_system: 'Операційна система',
        operating_system_zh: 'Операційна система (китайською)',
        operating_system_en: 'Операційна система (англійською)',
        brand: 'Бренд',
        country_region: 'Країна/регіон',
    },
    // 希腊语
    elGR: {
        model: 'Μοντέλο',
        mileage: 'Χιλιομετρική ένδειξη',
        functiontype: 'Τύπος λειτουργίας',
        functiontypedesp_zh: 'Περιγραφή τύπου λειτουργίας (Κινεζικά)',
        functiontypedesp_en: 'Περιγραφή τύπου λειτουργίας (Αγγλικά)',
        channel: 'Κανάλι',
        channeldesp_zh: 'Περιγραφή καναλιού (Κινεζικά)',
        channeldesp_en: 'Περιγραφή καναλιού (Αγγλικά)',
        functionstarttime: 'Ώρα έναρξης λειτουργίας',
        OS_version_beforere_freshing: 'Έκδοση λειτουργικού συστήματος πριν την ανανέωση',
        part_number_before_refreshing: 'Αριθμός ανταλλακτικού πριν την ανανέωση',
        vehicle_software_OS_version: 'Έκδοση λειτουργικού συστήματος λογισμικού οχήματος',
        controller_name: 'Όνομα ελεγκτή',
        hardware_number: 'Αριθμός υλικού',
        software_information_before_Refresh: 'Πληροφορίες λογισμικού πριν την ανανέωση',
        software_information_after_Refresh: 'Πληροφορίες λογισμικού μετά την ανανέωση',
        write_software_information: 'Εγγεγραμμένες πληροφορίες λογισμικού',
        function_name: 'Όνομα λειτουργίας',
        minor_process_execution_time: 'Διάρκεια εκτέλεσης μικρής διαδικασίας',
        small_process_execution_result: 'Αποτέλεσμα εκτέλεσης μικρής διαδικασίας',
        function_execution_time: 'Διάρκεια εκτέλεσης λειτουργίας',
        function_execution_result: 'Αποτέλεσμα εκτέλεσης λειτουργίας',
        function_execution_result_desp_zh: 'Περιγραφή αποτελέσματος (Κινεζικά)',
        function_execution_result_desp_en: 'Περιγραφή αποτελέσματος (Αγγλικά)',
        log_start_time: 'Ώρα έναρξης καταγραφής',
        log_end_time: 'Ώρα λήξης καταγραφής',
        vehicle_recognition_method: 'Μέθοδος αναγνώρισης οχήματος',
        vehicle_recognition_method_desp_zh: 'Περιγραφή μεθόδου αναγνώρισης (Κινεζικά)',
        vehicle_recognition_method_desp_en: 'Περιγραφή μεθόδου αναγνώρισης (Αγγλικά)',
        model_year: 'Έτος μοντέλου',
        vehicle_configuration_information: 'Πληροφορίες διαμόρφωσης οχήματος',
        platform: 'Πλατφόρμα',
        login_account: 'Λογαριασμός σύνδεσης',
        user_name: 'Όνομα χρήστη',
        service_center: 'Κέντρο εξυπηρέτησης',
        SIPS_version: 'Έκδοση SIPS',
        VDI_version: 'Έκδοση VDI',
        VDI_connection_method: 'Μέθοδος σύνδεσης VDI',
        VDI_connection_method_desp_zh: 'Περιγραφή μεθόδου σύνδεσης VDI (Κινεζικά)',
        VDI_connection_method_desp_en: 'Περιγραφή μεθόδου σύνδεσης VDI (Αγγλικά)',
        operating_system: 'Λειτουργικό σύστημα',
        operating_system_zh: 'Λειτουργικό σύστημα (Κινεζικά)',
        operating_system_en: 'Λειτουργικό σύστημα (Αγγλικά)',
        brand: 'Μάρκα',
        country_region: 'Χώρα/Περιοχή',
    },
    // 爱沙尼亚
    etEE: {
        model: 'Mudel',
        mileage: 'Sõidukilomeetrid',
        functiontype: 'Funktsiooni tüüp',
        functiontypedesp_zh: 'Funktsiooni tüübi kirjeldus (hiina keeles)',
        functiontypedesp_en: 'Funktsiooni tüübi kirjeldus (inglise keeles)',
        channel: 'Kanal',
        channeldesp_zh: 'Kanali kirjeldus (hiina keeles)',
        channeldesp_en: 'Kanali kirjeldus (inglise keeles)',
        functionstarttime: 'Funktsiooni algusaeg',
        OS_version_beforere_freshing: 'OS-i versioon enne värskendamist',
        part_number_before_refreshing: 'Osa number enne värskendamist',
        vehicle_software_OS_version: 'Sõiduki tarkvara OS-i versioon',
        controller_name: 'Juhtseadme nimi',
        hardware_number: 'Riistvara number',
        software_information_before_Refresh: 'Tarkvarateave enne värskendamist',
        software_information_after_Refresh: 'Tarkvarateave pärast värskendamist',
        write_software_information: 'Kirjutatud tarkvarateave',
        function_name: 'Funktsiooni nimi',
        minor_process_execution_time: 'Väikese protsessi täitmise kestus',
        small_process_execution_result: 'Väikese protsessi täitmise tulemus',
        function_execution_time: 'Funktsiooni täitmise kestus',
        function_execution_result: 'Funktsiooni täitmise tulemus',
        function_execution_result_desp_zh: 'Tulemuse kirjeldus (hiina keeles)',
        function_execution_result_desp_en: 'Tulemuse kirjeldus (inglise keeles)',
        log_start_time: 'Logi algusaeg',
        log_end_time: 'Logi lõpuaeg',
        vehicle_recognition_method: 'Sõiduki tuvastamise viis',
        vehicle_recognition_method_desp_zh: 'Tuvastamise viisi kirjeldus (hiina keeles)',
        vehicle_recognition_method_desp_en: 'Tuvastamise viisi kirjeldus (inglise keeles)',
        model_year: 'Mudeliaasta',
        vehicle_configuration_information: 'Sõiduki konfiguratsiooniteave',
        platform: 'Platvorm',
        login_account: 'Sisselogimiskonto',
        user_name: 'Kasutajanimi',
        service_center: 'Teeninduskeskus',
        SIPS_version: 'SIPS-i versioon',
        VDI_version: 'VDI versioon',
        VDI_connection_method: 'VDI ühenduse meetod',
        VDI_connection_method_desp_zh: 'VDI ühenduse kirjeldus (hiina keeles)',
        VDI_connection_method_desp_en: 'VDI ühenduse kirjeldus (inglise keeles)',
        operating_system: 'Operatsioonisüsteem',
        operating_system_zh: 'Operatsioonisüsteem (hiina keeles)',
        operating_system_en: 'Operatsioonisüsteem (inglise keeles)',
        brand: 'Bränd',
        country_region: 'Riik/piirkond',
    },
    // 哈萨克
    kkKZ: {
        model: 'Автокөлік моделі',
        mileage: 'Жүрілген жол',
        functiontype: 'Функция түрі',
        functiontypedesp_zh: 'Функция түрінің сипаттамасы (қытайша)',
        functiontypedesp_en: 'Функция түрінің сипаттамасы (ағылшынша)',
        channel: 'Арна',
        channeldesp_zh: 'Арнаның сипаттамасы (қытайша)',
        channeldesp_en: 'Арнаның сипаттамасы (ағылшынша)',
        functionstarttime: 'Функцияның басталу уақыты',
        OS_version_beforere_freshing: 'Жаңарту алдындағы ОЖ нұсқасы',
        part_number_before_refreshing: 'Жаңарту алдындағы бөлшек нөмірі',
        vehicle_software_OS_version: 'Автокөлік бағдарламалық қамтамасыз етуінің ОЖ нұсқасы',
        controller_name: 'Басқарғыштың атауы',
        hardware_number: 'Құрылғы нөмірі',
        software_information_before_Refresh: 'Жаңарту алдындағы бағдарламалық ақпарат',
        software_information_after_Refresh: 'Жаңартылған бағдарламалық ақпарат',
        write_software_information: 'Жазылған бағдарламалық ақпарат',
        function_name: 'Функция атауы',
        minor_process_execution_time: 'Кіші процесті орындау уақыты',
        small_process_execution_result: 'Кіші процесті орындау нәтижесі',
        function_execution_time: 'Функцияны орындау уақыты',
        function_execution_result: 'Функцияны орындау нәтижесі',
        function_execution_result_desp_zh: 'Орындау нәтижесінің сипаттамасы (қытайша)',
        function_execution_result_desp_en: 'Орындау нәтижесінің сипаттамасы (ағылшынша)',
        log_start_time: 'Журналдың басталу уақыты',
        log_end_time: 'Журналдың аяқталу уақыты',
        vehicle_recognition_method: 'Автокөлікті анықтау әдісі',
        vehicle_recognition_method_desp_zh: 'Анықтау әдісінің сипаттамасы (қытайша)',
        vehicle_recognition_method_desp_en: 'Анықтау әдісінің сипаттамасы (ағылшынша)',
        model_year: 'Модель жылы',
        vehicle_configuration_information: 'Автокөлік конфигурациясы туралы ақпарат',
        platform: 'Платформа',
        login_account: 'Кіру тіркелгісі',
        user_name: 'Пайдаланушы аты',
        service_center: 'Қызмет көрсету орталығы',
        SIPS_version: 'SIPS нұсқасы',
        VDI_version: 'VDI нұсқасы',
        VDI_connection_method: 'VDI байланыс әдісі',
        VDI_connection_method_desp_zh: 'VDI байланыс әдісінің сипаттамасы (қытайша)',
        VDI_connection_method_desp_en: 'VDI байланыс әдісінің сипаттамасы (ағылшынша)',
        operating_system: 'Операциялық жүйе',
        operating_system_zh: 'Операциялық жүйе (қытайша)',
        operating_system_en: 'Операциялық жүйе (ағылшынша)',
        brand: 'Бренд',
        country_region: 'Ел/аймақ',
    },
    // 希伯来语
    heIL: {
        model: 'דגם',
        mileage: 'קילומטראז\'',
        functiontype: 'סוג פונקציה',
        functiontypedesp_zh: 'תיאור סוג הפונקציה (בסינית)',
        functiontypedesp_en: 'תיאור סוג הפונקציה (באנגלית)',
        channel: 'ערוץ',
        channeldesp_zh: 'תיאור הערוץ (בסינית)',
        channeldesp_en: 'תיאור הערוץ (באנגלית)',
        functionstarttime: 'שעת תחילת הפונקציה',
        OS_version_beforere_freshing: 'גרסת מערכת ההפעלה לפני רענון',
        part_number_before_refreshing: 'מספר חלק לפני רענון',
        vehicle_software_OS_version: 'גרסת מערכת ההפעלה של תוכנת הרכב',
        controller_name: 'שם הבקר',
        hardware_number: 'מספר חומרה',
        software_information_before_Refresh: 'מידע על התוכנה לפני רענון',
        software_information_after_Refresh: 'מידע על התוכנה לאחר רענון',
        write_software_information: 'מידע על התוכנה שנכתב',
        function_name: 'שם הפונקציה',
        minor_process_execution_time: 'משך זמן ביצוע תת-תהליך',
        small_process_execution_result: 'תוצאות ביצוע תת-תהליך',
        function_execution_time: 'משך זמן ביצוע הפונקציה',
        function_execution_result: 'תוצאות ביצוע הפונקציה',
        function_execution_result_desp_zh: 'תיאור תוצאות הביצוע (בסינית)',
        function_execution_result_desp_en: 'תיאור תוצאות הביצוע (באנגלית)',
        log_start_time: 'שעת תחילת היומן',
        log_end_time: 'שעת סיום היומן',
        vehicle_recognition_method: 'שיטת זיהוי הרכב',
        vehicle_recognition_method_desp_zh: 'תיאור שיטת הזיהוי (בסינית)',
        vehicle_recognition_method_desp_en: 'תיאור שיטת הזיהוי (באנגלית)',
        model_year: 'שנת דגם',
        vehicle_configuration_information: 'פרטי תצורת הרכב',
        platform: 'פלטפורמה',
        login_account: 'חשבון כניסה',
        user_name: 'שם משתמש',
        service_center: 'מרכז שירות',
        SIPS_version: 'גרסת SIPS',
        VDI_version: 'גרסת VDI',
        VDI_connection_method: 'שיטת חיבור VDI',
        VDI_connection_method_desp_zh: 'תיאור שיטת החיבור (בסינית)',
        VDI_connection_method_desp_en: 'תיאור שיטת החיבור (באנגלית)',
        operating_system: 'מערכת הפעלה',
        operating_system_zh: 'מערכת הפעלה (בסינית)',
        operating_system_en: 'מערכת הפעלה (באנגלית)',
        brand: 'מותג',
        country_region: 'מדינה/אזור',
    },
};
